module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABaElEQVQokY3Sz4vNYRTH8de93duwmNlbKGJpMclYiqQozdb3hJrUpCxIDaVsLGRK8iuGFBvjXJasMFJ2UpOFzawk4Q+YLFj4WtwzdcnCU2fxfM67z3N6PqfTtq3RExF7cQM/ShrDycx8Ncp1C+5HxM7SvmMZu6qWsVrc/oiYgE7btiJiGlfxCJvwDnfL6Dgmy3AWFzDfaZpma0GXsA/rMvPUX+Nfx088wTXM9tDgZWYuYanAAziCFoujRhExQHQxhd0Rsa0ae8rsI76hKU0xBzHZxQw+42yZHsNKZp7PzDNYKQ3m8AlHe+j7/7MeHXR7eGyY2Vw172MmIi6XvrE0uId5LHbxAs8z8wNk5msMsAGbMShNfeAC3naaptmCK7iIQ+j/I47b+IoHVafXFuAwHhqu2jje+3MBduCLYUQLmO9W8ymm66U7hhH1q6ZwMzPP4QRuZeavXs2+imdlMo7teFP3MUwUt8b4Dd6igfFE4VUgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/top_set.png
// module id = CSRi
// module chunks = 0